import { Media } from '@/payload-types'
import { VideoStatus } from '@/enum/enum'

export enum VideoSource {
  MUX = 'mux',
  VIDEOJS = 'videojs',
  CUSTOM = 'custom',
}

export const getVideoSource = (mediaData: Media) => {
  if (
    (!mediaData.mux?.status && !!mediaData.url) ||
    (mediaData.mux?.status != VideoStatus.READY &&
      mediaData.backupBucketUrl?.startsWith('/api/media/file/mux-videos%2F'))
  ) {
    return VideoSource.CUSTOM
  } else if (!!mediaData.mux?.status) {
    return VideoSource.MUX
  } else {
    return null
  }
}
